import {useEffect, useState} from 'react';
import {useRecoilState} from 'recoil';
import classNames from 'classnames';
import useNewLineText from '@src/hooks/useNewLineText';
import {layerState} from '@src/store';
import {ListLayerData} from '@src/types/common';

function ListLayer () {
  const [{data, callback}, setLayer] = useRecoilState(layerState);

  const {title, desc, list, initialValue = ''} = data as ListLayerData;
  const [selectedValue, setSelectedValue] = useState<string>(initialValue);
  const [isError, setIsError] = useState(false);
  const trimDesc = useNewLineText(desc || '');

  useEffect(() => {
    if (isError && selectedValue) {
      setIsError(false);
    }
  }, [selectedValue, isError]);

  const handleClickClose = () => {
    setLayer({open: false});
  };

  const handleClickConfirm = () => {
    if (!selectedValue) {
      setIsError(true);
      return;
    }
    handleClickClose();
    callback && callback(selectedValue);
  };

  return (
    // <!-- error 클레스 추가 -->
    <div className={classNames('inner_layer', {error: isError})}>
      <div className="layer_head">
        <strong className="tit_layer">{title}</strong>
      </div>
      <div className="layer_body">
        <p className="desc_layer">{trimDesc}</p>
        <ul className="list_conditaions">
          {list.map((li, index) => {
            const {desc: liDesc, value} = li;
            return (
              <li key={index}>
                <label className="lab_radio">
                  <input
                    type="radio"
                    name="inpCancel"
                    onChange={() => setSelectedValue(value)}
                    checked={selectedValue === value}
                  />
                  <span className="txt_radio ico_g_bf">{liDesc}</span>
                </label>
              </li>
            );
          })}
        </ul>
        {isError && <p className="txt_error">항목을 선택해 주세요.</p>}
      </div>
      <div className="layer_foot">
        <div className="bundle_btn">
          <button
            type="button"
            className="btn_ok"
            onClick={handleClickConfirm}
            data-tiara-action-name={data.tiaraActionName || ''}
            data-tiara-action-kind={data.tiaraActionType || ''}
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
}

export default ListLayer;
